import {
  DialogButton as OriginalDialogButton,
  Form as OriginalForm,
  PasswordField as OriginalPasswordField,
  Submit as OriginalSubmit,
} from 'shared/containers/form';

import LabelledSelect from 'shared/components/LabelledSelect';
import MUIButton from '@mui/material/Button';
import MUITextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const Root = styled.div`
  h2 {
    color: #48596B;
    font-size: 24px;
    font-weight: 700;
  }
  .half {
    width: 50%;
    &:nth-of-type(1) {
      padding-right: 15px;
    }
    &:nth-of-type(2) {
      padding-left: 15px;
    }
  }
  label {
    color: #48596B;
    font-size: 16px;
    font-weight: 700;
  }
  .optional {
    font-weight: 400;
    font-style: italic;
    color: #48596B;
    font-size: 14px;
    float: right;
  }
  .help {
    color: #0072A2;
    font-size: 16px;
    font-weight: 700;
    float: right;
    width: 32px;
    height: 32px;
    background-color: #EAF0F6;
    text-align: center;
    padding-top: 3px;
    border-radius: 50%;
  }
  .regular-text {
    color: #48596B;
    font-size: 16px;
    font-weight: 400;
    margin: 0 0 12px 0;
  }
  .help-text {
    font-weight: 400;
    font-style: italic;
    color: #48596B;
    font-size: 14px;
  }
  .error-text {
    font-weight: 400;
    font-style: italic;
    color: #FF4444;
    font-size: 14px;
  }  
  .MuiChip-root {
    width: 100%;
    &.error {
      border: solid 1px #ff7272;
      color:  #ff7272;
      margin-bottom: 10px;
      svg {
        color:  #ff7272;
      }
    }
    &.MuiChip-colorPrimary {
      border: solid 1px #0072A2;
      color: #0072A2;
      svg {
        color:  #0072A2;
      }
    }
  }

  ${({ minWidth }) => minWidth && `min-width: ${minWidth}px`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px`}
    align-self: center;
    margin-bottom: 20px;
`;

const fieldAttrs = {
  autoComplete: 'off',
};

export const TextField = styled(MUITextField).attrs(fieldAttrs)`
`;

export const PasswordField = styled(OriginalPasswordField)`
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const Footer = styled(Row)`
  margin-top: 20px;
  justify-content: space-around;
`;

export const Instructions = styled(Typography)`
  font-size: 16px !important;
  line-height: 1.5;
  background: #EAF0F6;
`;

const buttonAttrs = {
  variant: 'contained',
};

export const Submit = styled(OriginalSubmit).attrs({
  ...buttonAttrs,
  color: 'primary',
})`
  text-transform: none !important;
  .MuiButton-label {
    font-weight: bold !important
    font-size: 16px !important;
  }
`;

export const Button = styled(MUIButton)`
  span {
    text-transform: none !important;
    font-size: 16px;
    font-weight: 700;
  }
  max-width: 200px;
  &.full {
    max-width: 100%;
    min-width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Center = styled(Column)`
  flex: 1 1 auto;
  align-items: center;
`;

export const Form = styled(OriginalForm)`
  display: flex;
  flex-direction: column;
  .scroller-drawer {
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const DialogButton = styled(OriginalDialogButton).attrs({
  negativeButtonComponent: Button,
  positiveButtonComponent: Submit,
  formComponent: Form,
})`
`;

export const NarrowSelect = styled(LabelledSelect).attrs(fieldAttrs)`
  width: 200px;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #CBD6E2;
  margin: 20px 0;
`;

export const RequiredMark = styled.span`
  color: #FF4444;
  margin-left: 2px;
  font-weight: 700;
`;

export const ValidationSummary = styled.div`
  background: #EAF0F6;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  .summary-title {
    color: #48596B;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  .summary-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: #48596B;
    font-size: 16px;
    line-height: 1.4;
    svg {
      padding: 4px 2px;
    }
    .error {
      color: #BB1B00;
    }
    .success {
      color: #219653;
    }
  }
`;